/**
 * Canonical set of action types whose outputs should be mocked in recipes.
 *
 * Includes all non-scope action types. Scope types (If, Switch, Foreach,
 * Until, Scope) are excluded as they contain nested actions rather than
 * producing direct outputs.
 *
 * When generating a recipe from a completed run, only actions with a type in
 * this set will have their outputs captured as mock data.
 */

export const MOCKABLE_ACTION_TYPES: ReadonlySet<string> = new Set([
  // Connectors & External Calls
  'ApiConnection',
  'ApiConnectionNotification',
  'ApiConnectionWebhook',

  'Http',
  'HttpWebhook',
  'ServiceProvider',
  'Workflow',

  // Request trigger
  'Request',
]);

/** Case-insensitive check for whether an action type is mockable. */
export function isMockableType(type: string): boolean {
  if (MOCKABLE_ACTION_TYPES.has(type)) return true;
  // Fallback: case-insensitive lookup
  const lower = type.toLowerCase();
  for (const t of MOCKABLE_ACTION_TYPES) {
    if (t.toLowerCase() === lower) return true;
  }
  return false;
}
